// extracted by mini-css-extract-plugin
module.exports = {"root":"TopologiesTable_root__3Xy2M","name":"TopologiesTable_name__1-mic"};